import { BaseIcon } from './base';
import type { IconSmallProps } from './base';

export function IconAccessSmall(props: IconSmallProps) {
  return (
    <BaseIcon {...props} size={16} viewBox="0 0 16 16">
      <path
        d="M8.11937 3.0008C4.7875 2.95531 1.65289 4.84182 1.02331 7.78022C0.992196 7.92545 0.992229 8.07617 1.02341 8.22139C1.6359 11.0738 4.62358 12.9547 7.88063 12.9992C11.2125 13.0447 14.3471 11.1582 14.9767 8.21976C15.0078 8.07453 15.0078 7.9238 14.9766 7.77858C14.3641 4.92617 11.3764 3.04527 8.11937 3.0008ZM7.90519 10.9993C5.2814 10.9635 3.39897 9.53845 2.93067 8.00033C3.23121 7.01162 4.11421 6.07646 5.38951 5.52066C5.14158 5.95722 5 6.46208 5 7C5 8.65685 6.34315 10 8 10C9.65685 10 11 8.65685 11 7C11 6.46206 10.8584 5.95719 10.6105 5.52062C11.8914 6.07794 12.7697 7.01566 13.0693 7.99965C12.5868 9.58691 10.6032 11.0362 7.90519 10.9993ZM7 7C7 6.44772 7.44772 6 8 6C8.55228 6 9 6.44772 9 7C9 7.55228 8.55228 8 8 8C7.44772 8 7 7.55228 7 7Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
